import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { CTAButton } from '../ui/CTAButton';
export function FinalCTASection() {
  return <section id="pricing" className="py-24 px-4 bg-gradient-to-t from-[var(--bg-deepest)] to-[var(--bg-primary)]" data-id="element-1">
      <div className="max-w-3xl mx-auto text-center" data-id="element-2">
        <SectionWrapper data-id="element-3">
          <div className="mb-12" data-id="element-4">
            <h2 className="text-4xl md:text-6xl text-[var(--text-primary)] mb-6 leading-tight" data-id="element-5">
              Si hoy estás cansada de dormir "a pedazos", <br data-id="element-6" />
              <span className="text-[var(--accent-teal)]" data-id="element-7">
                entra al 3AM Club.
              </span>
            </h2>
            <p className="text-xl md:text-2xl text-[var(--text-secondary)] mb-8" data-id="element-8">
              No porque sea divertido. Sino porque es real. <br data-id="element-9" />Y porque esta
              vez no vas a depender de suerte.
            </p>
          </div>
        </SectionWrapper>

        <SectionWrapper delay={0.2} data-id="element-10">
          <div id="final-cta" className="bg-[var(--bg-card)] p-8 md:p-12 rounded-3xl border border-[var(--accent-amber)]/20 shadow-2xl shadow-[var(--accent-amber)]/5 mb-12" data-id="element-11">
            <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-8" data-id="element-12">
              <div className="w-32 h-32 md:w-40 md:h-40 rounded-xl overflow-hidden shadow-lg shrink-0" data-id="element-13">
                <img src="https://cdn.magicpatterns.com/uploads/1jq1C9ncd8Lzqzk4ABRW7q/heylloyd-image-1770594370603.png" alt="3AM Club Cover" className="w-full h-full object-cover" data-id="element-14" />
              </div>
              <div className="text-left" data-id="element-15">
                <h3 className="text-2xl font-bold text-[var(--text-primary)] mb-2" data-id="element-16">
                  3AM Club Protocolo
                </h3>
                <p className="text-[var(--text-secondary)] mb-4" data-id="element-17">
                  Protocolo Digital + Bonos
                </p>
                <div className="flex items-baseline gap-2" data-id="element-18">
                  <span className="text-4xl font-bold text-[var(--text-primary)]" style={{
                  fontWeight: '700'
                }} data-id="element-19">
                    $6.36
                  </span>
                  <span className="text-[var(--text-muted)] line-through" data-id="element-20">
                    $19.99
                  </span>
                </div>
              </div>
            </div>

            <CTAButton text="Consigue 3AM Club Ahora" size="xl" className="w-full md:w-auto" href="https://aprendeaplica.com/cart/52157618159895:1" data-id="element-21" />

            <p className="mt-6 text-sm text-[var(--text-muted)]" data-id="element-22">
              (Descarga inmediata. Léelo hoy. Usa el Reset esta noche.)
            </p>
          </div>
        </SectionWrapper>

        <SectionWrapper delay={0.4} data-id="element-23">
          <p className="text-sm text-[var(--text-muted)]" data-id="element-24">
            © 2024 3AM Club. Todos los derechos reservados.
          </p>
        </SectionWrapper>
      </div>
    </section>;
}